export default __webpack_public_path__ + "static/media/soap.f66670b0.webp";